import { useState } from 'react';
import { SearchBarWrapper, SearchIcon, SearchInput } from './SearchButton.styled';
import { SearchButtonProps } from './SearchButton.types';

const SearchButton = (props: SearchButtonProps) => {

    const { placeholder, handleSearch, value } = props;

    return (
        <SearchBarWrapper>
        <SearchInput
            data-testid="search-input"
            type="text"
            placeholder={placeholder}
            value={value}
            onChange={handleSearch}
        />
        <SearchIcon />
        </SearchBarWrapper>
    );
};

export default SearchButton;